import { render, staticRenderFns } from "./featureDetail.vue?vue&type=template&id=3edb3b0b"
import script from "./featureDetail.vue?vue&type=script&lang=js"
export * from "./featureDetail.vue?vue&type=script&lang=js"
import style0 from "./featureDetail.vue?vue&type=style&index=0&id=3edb3b0b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports